import { b2cPagesService } from '@clubmed/utils';
import { resort, price } from 'Views/configQueries';
import graphQLClient from 'Utils/graphql-client/graphqlClient';
import { addTranslationKeys } from 'Src/i18n';
import resortThumbnailQuery from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import type { ThumbnailProduct } from 'Utils/resort-thumbnail-query/resortThumbnailQuery';
import { LINE_PRODUCT_SUMMARY } from 'Utils/request/requestDictionary';
type CMSProps = {
  color: BrandColors;
  resortId: string;
  tourDurationPlaceholder: string;
  cruiseTimingPlaceholder: string;
  cruiseDurationPlaceholder: string;
  dateFormat: string;
};
type GQLProps = {
  product: ThumbnailProduct;
  config: Partial<{
    common: {
      close: string;
    };
  }>;
};
export type ProductSummaryDescriptorProps = CMSProps & GQLProps;
export const resolve: Resolve<GQLProps, CMSProps> = async (appContext, props, pageContext) => {
  const { cmsContent = '', cmsRelease = '' } = appContext;
  const cmsArgs = `content : "${cmsContent}", release : "${cmsRelease}"`;
  const isMice = b2cPagesService.isMicePage(pageContext.pageType);
  const {
    resortId,
    tourDurationPlaceholder,
    cruiseTimingPlaceholder,
    cruiseDurationPlaceholder,
    dateFormat,
  } = props;
  const resortThumbnailQueryString = resortThumbnailQuery({
    content: cmsContent,
    release: cmsRelease,
    isMice,
    tourDurationPlaceholder,
    cruiseTimingPlaceholder,
    cruiseDurationPlaceholder,
    dateFormat,
  });
  const query = `query {
    product : resort(productId : "${resortId}") {
      description
      ${resortThumbnailQueryString}
    }
    config(${cmsArgs}) {
      ${resort(appContext)}
      ${price()}
      common {
        next
        previous
        close
      }
    }
  }`;
  return graphQLClient
    .runQuery(query, appContext, {
      requestName: LINE_PRODUCT_SUMMARY,
      strictErrors: false,
    })
    .then((data) => {
      addTranslationKeys(data.config);
      return data;
    })
    .catch(() => {});
};
